import { loadingBarReducer } from "react-redux-loading-bar";
import { routerReducer } from "react-router-redux";
import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import accountReducer from "./account/account.reducer";
import addressReducer from "./address/address.reducer";
import addressesReducer from "./address/addresses.reducer";
import searchAddressReducer from "./address/searchaddress.reducer";
import companiesReducer from "./company/companies.reducer";
import companyReducer from "./company/company.reducer";
import contactReducer from "./contact/contact.reducer";
import contactsReducer from "./contact/contacts.reduder";
import searchcontractorReducer from "./contractor/searchcontractor.reducer";
import customerReducer from "./customer/customer.reducer";
import customersReducer from "./customer/customers.reducer";
import searchCustomerReducer from "./customer/searchcustomer.reducer";
import employeeReducer from "./employee/employee.reducer";
import employeesReducer from "./employee/employees.reducer";
import searchEmployeeReducer from "./employee/searchemployee.reducer";
import loaderReducer from "./loader/loader.reducer";
import providerReducer from "./provider/provider.reducer";
import providersReducer from "./provider/providers.reducer";
import serviceAgentsReducer from "./service/serviceAgents.reducer";
import searchServiceReducer from "./service/searchservice.reducer";
import serviceReducer from "./service/service.reducer";
import servicesReducer from "./service/services.reducer";
import serviceOrderReducer from "./serviceOrder/serviceOrder.reducer";
import serviceOrdersReducer from "./serviceOrder/serviceOrders.reducer";
import budgetReducer from "./budget/budget.reducer";
import budgetsReducer from "./budget/budgets.reducer";
import budgetProposalsReducer from "./budget/proposals.reducer";
import budgetProposalReducer from "./budget/proposal.reducer";
import dashboardsReducer from "./dashboard/dashboards.reducer";
import invoicesReducer from "./invoice/invoices.reducer";
import invoiceReducer from "./invoice/invoice.reducer";
import invoiceOrderServices from "./invoice/invoiceOrderservices.reducer";
import questionnairesReducer from "./quiz/questionnaires.reducer";
import quizReducer from "./quiz/quiz.reducer";
import reportReducer from "./report/report.reducer";
import reportsReducer from "./report/reports.reducer";
import providersSelectedReducer from "./providerSelected/providersSelected.reducer";
import agentSelectReducer from "./providerSelected/agentSelected.reducer";
import searchTontonAddress from "./address/searchTontonAddress.reducer";
import fileReducer from "./file/file.reducer";
import filesReducer from "./file/files.reducer";
import receiptsReducer from "./file/receipts.reducer";
import providerReceiptsReducer from "./file/providerReceipts.reducer";
import filesOrderServiceReducer from "./file/filesOrderService.reducer";
import saveEmailReducer from "./account/saveEmail.reducer";
import filesServiceOrderReducer from "./serviceOrder/filesServiceOrder.reducer";
import notificationsReducer from "./notification/notifications.reducer";
import providerHirersReducer from "./provider/providerHires.reducer";
import checkEmailReducer from "./checkEmail/checkEmail.reducer"

const rootReducer = combineReducers({
  routerReducer: routerReducer,
  form: formReducer,
  loadingBar: loadingBarReducer,
  loading: loaderReducer,
  companies: companiesReducer,
  company: companyReducer,
  employees: employeesReducer,
  employee: employeeReducer,
  customer: customerReducer,
  customers: customersReducer,
  addresses: addressesReducer,
  address: addressReducer,
  contacts: contactsReducer,
  service: serviceReducer,
  services: servicesReducer,
  contractorServiceOrders: serviceOrdersReducer,
  serviceOrder: serviceOrderReducer,
  serviceOrders: serviceOrdersReducer,
  agents: serviceAgentsReducer,
  contact: contactReducer,
  provider: providerReducer,
  providers: providersReducer,
  searchcontractor: searchcontractorReducer,
  searchEmployee: searchEmployeeReducer,
  searchcustomer: searchCustomerReducer,
  searchaddress: searchAddressReducer,
  searchservice: searchServiceReducer,
  budget: budgetReducer,
  budgets: budgetsReducer,
  budgetProposals: budgetProposalsReducer,
  budgetProposal: budgetProposalReducer,
  account: accountReducer,
  dashboards: dashboardsReducer,
  invoices: invoicesReducer,
  invoice: invoiceReducer,
  invoiceOrderServices: invoiceOrderServices,
  questionnaires: questionnairesReducer,
  quiz: quizReducer,
  report: reportReducer,
  reports: reportsReducer,
  providersSelected: providersSelectedReducer,
  agentsSelected: agentSelectReducer,
  tontonAddresses: searchTontonAddress,
  file: fileReducer,
  files: filesReducer,
  receipts: receiptsReducer,
  providerReceipts: providerReceiptsReducer,
  filesOrderService: filesOrderServiceReducer,
  saveEmail: saveEmailReducer,
  filesTecSubmit: filesServiceOrderReducer,
  notifications: notificationsReducer,
  providerHirers: providerHirersReducer,
  checkEmail: checkEmailReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/root.reducer.js